module.exports = __webpack_public_path__ + "img/goodys_headache_powder_stick_packets_extra_strength.bb6e3d5e.png";